import { createCrudActions } from '../utils/crudGenerator';

const formatLocations = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchLocations,
    create: createLocation,
    update: updateLocation,
    delete: deleteLocations
} = createCrudActions('LOCATION', "Ubicación", formatLocations);